import { useEffect } from 'react';
import HeroCarousel from '@/pages/home/components/HeroCarousel';
import CategoryQuickLinks from '@/pages/home/components/CategoryQuickLinks';
import HotWorks from '@/pages/home/components/HotWorks';
import LatestWorks from '@/pages/home/components/LatestWorks';
import TopicCollections from '@/pages/home/components/TopicCollections';
import SiteIntro from '@/pages/home/components/SiteIntro';

const HOME_TITLE = '长日光阴 - 多元影视作品推荐与剧情介绍平台';
const HOME_DESC =
  '长日光阴网站提供丰富的影视剧集、电影资源及剧情介绍，覆盖热门电影和电视剧，满足用户多样的观影需求。';

export default function Home() {
  useEffect(() => {
    document.title = HOME_TITLE;
    const desc = document.querySelector('meta[name="description"]');
    if (desc) desc.setAttribute('content', HOME_DESC);
  }, []);

  return (
    <>
      <HeroCarousel />
      <CategoryQuickLinks />
      <HotWorks />
      <LatestWorks />
      <TopicCollections />
      <SiteIntro />
    </>
  );
}